import { compose } from 'recompose'
import ValuePropositionSmall from './ValuePropositionSmall'

export default compose()(ValuePropositionSmall)
